import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect, withRouter } from 'react-router-dom';
import ReactRouterPropTypes from 'react-router-prop-types';
import { connect } from 'react-redux';
import MainPage from '../components/MainPage';
import {
  getOperatorWorkRecords,
  getUserDevices,
  getBlackboardList,
} from '../actions/api/apis';
import getOperators from '../actions/api/operators/getOperators';
import getGroups from '../actions/api/group/getGroups';
import { SUCCESS_API_GET_USER_GROUPS } from '../actions/actionTypes';
import messages from '../lib/i18n';
import config from '../config';
import { REDIRECT_REASON } from '../lib/constants';

const { locale } = config;
const i18nMessages = messages[locale];
const INTERVAL_TIMER = 3000;

const updateContainer = (apiToken, dispatch, params) => {
  const { searchOptions = {}, operatorId, targetGroupId = null } = params;
  const groupIds = (targetGroupId && [targetGroupId]) || undefined;

  if (operatorId !== null || operatorId !== undefined) {
    dispatch(
      getOperatorWorkRecords(apiToken, {
        ...searchOptions,
        groupIds,
        operatorId,
      }),
    );
  }
  dispatch(getUserDevices(apiToken, operatorId));
};

const scrollTop = () => {
  // ページネーションなどでページ更新した時にスクロールバーをトップに戻す
  const obj = document.getElementById('canScrollTable');
  if (obj) {
    obj.scrollTop = 0;
  }
};
const blackboardScrollTop = () => {
  const obj = document.getElementById('canScrollTableBlackboard');
  if (obj) {
    obj.scrollTop = 0;
  }
};

const getSearchBoxHeight = () => {
  const searchBox = document.getElementById('TimeLinePageSearchBox');
  const toolBar = document.getElementById('TimeLineToolBar');
  const height =
    (searchBox && searchBox.clientHeight) + (toolBar && toolBar.clientHeight);
  return height || 0;
};

class TimeLineTileContainer extends Component {
  constructor(props) {
    super(props);
    const {
      match,
      dispatch,
      apiToken,
      refreshBlackboard,
      showUserPrompt,
      targetGroupId,
      isLogin,
      calendarData,
      innerRole,
    } = props;
    this.state = {
      searchBoxHeight: 0,
      refreshBlackboard,
    };
    const openCalendar = !!(calendarData && calendarData.name);
    const params = {
      match,
      apiToken,
      searchOptions: (props && props.searchOptions) || {},
      dispatch,
      showUserPrompt,
      openCalendar,
      canUpdate: !showUserPrompt || isLogin || !openCalendar,
      targetGroupId,
    };
    const operatorId = match.params.operatorId || null;
    params.searchOptions = { ...params.searchOptions, operatorId };
    dispatch(
      getOperators(apiToken, {
        ids: [operatorId],
        groupIds: targetGroupId ? [targetGroupId] : null,
      }),
    );
    dispatch(getGroups(apiToken, {}, SUCCESS_API_GET_USER_GROUPS));
    dispatch({ type: 'RESET_OPERATOR_INFO' });
    dispatch({ type: 'OPEN_TIMELINE_TILE' });
    const prevOperatorId = params.searchOptions.operatorId;
    if (prevOperatorId !== operatorId || match.url.includes('timelinetile')) {
      // operatorIdが変わった場合とtile表示になった場合は初期化
      dispatch({ type: 'RESET_OPERATOR_WORKS', operatorId });
    }
    if (params.canUpdate) {
      updateContainer(apiToken, dispatch, {
        searchOptions: params.searchOptions,
        operatorId,
        targetGroupId,
        innerRole,
      });
      this.initialTimer(params);
    }
  }

  componentDidMount() {
    const searchBoxHeight = getSearchBoxHeight();
    this.setState({ searchBoxHeight });
  }

  shouldComponentUpdate(props, state) {
    scrollTop();
    const { requireRedirect, redirectInfo, dispatch, history } = props;
    if (requireRedirect) {
      const { reason, path } = redirectInfo;
      if (reason === REDIRECT_REASON.noUser) {
        // 表示作業者が選択グループに存在しない場合はダッシュボードに遷移
        dispatch({ type: 'REDIRECT_DASHBOARD' });
        const promptMessage = [
          i18nMessages['userPrompt.message.noGroupUser.1'],
          i18nMessages['userPrompt.message.noGroupUser.2'],
        ];
        const buttonOk = i18nMessages['userPrompt.button.ok'];
        const buttonArray = [{ name: buttonOk, type: 0 }];
        const onAccept = ret => {
          if (ret === 0) {
            history.push(path);
          }
        };
        dispatch({
          type: 'OPEN_USER_PROMPT',
          promptMessage,
          buttonArray,
          onAccept,
        });
        return true;
      }
      if (reason === REDIRECT_REASON.groupAdmin) {
        dispatch({ type: 'REDIRECT_DASHBOARD' });
        history.push(path);
        return true;
      }
    }

    const { refreshBlackboard, apiToken, blackboardSearchOptions } = props;
    if (refreshBlackboard !== state.refreshBlackboard) {
      dispatch(getBlackboardList(apiToken, blackboardSearchOptions));
      this.setState({ refreshBlackboard });
      blackboardScrollTop();
      return true;
    }

    const resizedSearchBoxHeight = getSearchBoxHeight();
    const curSearchBoxHeight = state.searchBoxHeight;
    if (resizedSearchBoxHeight !== curSearchBoxHeight) {
      this.setState({ searchBoxHeight: resizedSearchBoxHeight });
    }
    const {
      calendarData,
      match,
      showUserPrompt,
      isLogin,
      targetGroupId,
      searchOptionsError,
      innerRole,
    } = props;
    const openCalendar = !!(calendarData && calendarData.name);
    const searchOptions = (props && props.searchOptions) || {};
    const operatorId = match.params.operatorId || null;
    const params = {
      match,
      apiToken,
      searchOptions: { ...searchOptions, operatorId },
      searchOptionsError,
      dispatch,
      showUserPrompt,
      openCalendar,
      canUpdate: !showUserPrompt || isLogin || !openCalendar,
      targetGroupId,
      innerRole,
    };
    if (
      !searchOptionsError.recordedDateFrom &&
      !searchOptionsError.recordedDateTo
    ) {
      this.initialTimer(params);
    }
    return true;
  }

  componentWillUnmount() {
    this.closeTimer();
    const { dispatch } = this.props;
    dispatch({
      type: 'SEARCHBOX_RESET_SEARCH_OPTIONS',
      caller: 'timeline-tile',
    });
  }

  initialTimer(params) {
    const {
      dispatch,
      apiToken,
      searchOptions,
      showUserPrompt,
      match,
      openCalendar,
      targetGroupId,
      innerRole,
    } = params;
    const { operatorId } = match.params;
    this.closeTimer();

    if (dispatch && apiToken && !showUserPrompt && !openCalendar) {
      updateContainer(apiToken, dispatch, {
        searchOptions,
        operatorId,
        targetGroupId,
        innerRole,
      });
      this.mainTimer = setInterval(
        () =>
          updateContainer(apiToken, dispatch, {
            searchOptions,
            operatorId,
            targetGroupId,
            innerRole,
          }),
        INTERVAL_TIMER,
      );
    }
  }

  closeTimer() {
    if (this.mainTimer !== undefined) {
      clearInterval(this.mainTimer);
      delete this.mainTimer;
    }
  }

  render() {
    const { isLogin } = this.props;
    const { searchBoxHeight } = this.state;
    return (
      (!isLogin && <Redirect to="/login" />) || (
        <MainPage searchBoxHeight={searchBoxHeight} />
      )
    );
  }
}

TimeLineTileContainer.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  dispatch: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  isLogin: PropTypes.bool.isRequired,
  apiToken: PropTypes.string.isRequired,
  searchOptions: PropTypes.object.isRequired,
  searchOptionsError: PropTypes.object.isRequired,
  showUserPrompt: PropTypes.bool.isRequired,
  calendarData: PropTypes.object.isRequired,
  refreshBlackboard: PropTypes.bool.isRequired,
  blackboardSearchOptions: PropTypes.object.isRequired,
  targetGroupId: PropTypes.string.isRequired,
  requireRedirect: PropTypes.bool.isRequired,
  redirectInfo: PropTypes.object.isRequired,
  innerRole: PropTypes.number.isRequired,
};

const mapStateToProps = state => ({
  isLogin: state.main.isLogin,
  apiToken: state.main.apiToken,
  refreshPage: state.operatorWorks.refreshPage,
  searchOptions: state.operatorWorks.searchOptions,
  searchOptionsError: state.operatorWorks.searchOptionsError,
  showUserPrompt: state.userPrompt.showUserPrompt,
  calendarData: state.main.calendarData,
  refreshBlackboard: state.blackboard.refresh,
  blackboardSearchOptions: state.blackboard.searchOptions,
  targetGroupId: state.main.targetGroupId,
  requireRedirect: state.main.requireRedirect,
  redirectInfo: state.main.redirectInfo,
  innerRole: state.main.innerRole,
});

export default withRouter(connect(mapStateToProps)(TimeLineTileContainer));
